import './components/Cookiebar'
import './components/DynamicForm'
import './components/FAQ'
import './components/ImageSlider'
import './components/Lightbox'

addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.main-navigation-mobile')) {
		let hamburgerMain: HTMLElement = document.querySelector('.main-navigation-mobile')

		hamburgerMain.addEventListener('click', function () {
			document.body.classList.toggle('menu-open')
		})
	}

	const menuItems = document.querySelectorAll('nav > ul.level-1 > li ')


	menuItems.forEach((item) => {
		item.addEventListener('click', function(){

			menuItems.forEach((otherItem) => {
				otherItem.classList.remove('active')
			})

			item.classList.add('active')
			document.body.classList.toggle('menu-open')
		})
	})
})